import { defineComponent as _defineComponent } from 'vue';
import { computed } from "vue";
import { useHistoryStore } from "@/stores/historyStore";
import GridInvocation from "../Grid/GridInvocation.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'HistoryInvocations',
    props: {
        historyId: null
    },
    setup(__props) {
        const props = __props;
        const { getHistoryNameById } = useHistoryStore();
        const historyName = computed(() => getHistoryNameById(props.historyId));
        return { __sfc: true, props, getHistoryNameById, historyName, GridInvocation };
    }
});
